
































import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { AmoNotification } from '@/requests/mainApi/models/AmoNotification';
import UiLoader from '@/components/ui/UiLoader.vue';
import Notification from './Notification.vue';
import NoNotificationsStub from './NoNotificationsStub.vue';
import { mapActions, mapGetters } from 'vuex';
import { debounce } from '@/utils/helpers/helpFunctions';

const limitStep = 20;

type FilterState = null | 'deal' | 'contract' | 'promo';

interface Data {
  observer: IntersectionObserver | null
  limit: number,
  setOfIdsToRead: Set<number>,
  filterState: FilterState
}

interface Methods {
  setLimit: (state: number) => void,
  onNotificationObserve: (entries: IntersectionObserverEntry[]) => void
  readNotifications: (params: {ids: number[]}) => void
  getNotifications: (params: any) => void
  setFilterState: (e: Event) => void
}

interface Computed {
  notifications: AmoNotification[],
  notificationsCount: number
}

interface Props {}

export default Vue.extend({
  name: 'Notifications',
  components: {
    Notification,
    NoNotificationsStub,
    UiLoader
  },
  data() {
    return {
      limit: limitStep,
      observer: null,
      setOfIdsToRead: new Set(),
      filterState: null
    };
  },
  computed: {
    ...mapGetters(['notifications', 'notificationsCount']),
    toShow() {
      return this.notifications.slice(0, this.limit)
    }
  },
  mounted() {      
    this.observer = new IntersectionObserver(this.onNotificationObserve,{
      root: document as unknown as Element,
      threshold: 1.0,
    })
    this.observer?.observe(this.$el.children[0].children[0]);
    this.getNotifications({ type: null });
  },
  beforeDestroy() {
    this.observer?.disconnect();
  },
  methods: {
    ...mapActions(['getNotifications', 'readNotifications']),
    setLimit(state) {
      this.limit = state
    },
    onNotificationObserve(entries: IntersectionObserverEntry[]) {
      entries.forEach(({ target, isIntersecting}) => {
        if (!isIntersecting) {
          return;
        }
        const el = (target as HTMLElement)
        if (+el.dataset.read === 0) {
          this.setOfIdsToRead.add(+el.dataset.id)
        }
        
        if (+el.dataset.id % limitStep === 0 && this.limit < this.notificationsCount) {
          this.setLimit(this.limit + limitStep)
        }
        if (this.setOfIdsToRead.size > 0) {
          debounce(() => {
            this.readNotifications({
              ids: [ ...this.setOfIdsToRead ]
            })
            this.setOfIdsToRead.clear()
          }, 700);
        }
        
        this.observer.unobserve(target);
      });
    },
    readObservedNotifications() {},
    setFilterState(e: Event) {
      const filter = (e.target as HTMLButtonElement).value || null;
      this.filterState = filter as FilterState;
      this.getNotifications({ type: filter as FilterState });
    }
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
